
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/estacion-de-esqui",
      function () {
        return require("private-next-pages/estacion-de-esqui.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/estacion-de-esqui"])
      });
    }
  